<template>
  <span>
    <div v-if="showDetails" class="caption">{{ element.id }}</div>
    <div
      v-if="element.id"
      :color="elementColor"
      :class="`${!element.loading && ((showLogicalLanguage && !element.prolog) || (!showLogicalLanguage && !element.name)) ? 'rai-custom-chip__red-border' : ''}
        raison-element-chip`"
      v-on="clickable ? { click: () => $emit('elementSelected', element) } : {}"
    >
      <span class="rai-natural-language">
        {{ !showLogicalLanguage ? element.name || $t('global.notranslation') : element.prolog || $t('global.notranslation') }}
      </span>
    </div>
  </span>
</template>

<script>
import naturalOrLogicalLanguageMixin from '@/mixins/natural-or-logical-language-mixin.js';

export default {
  name: 'ElementChip',

  mixins: [ naturalOrLogicalLanguageMixin ],

  props: {
    element: {
      type: Object,
      required: true,
    },
    clickable: {
      type: Boolean,
      required: false,
      default: false
    },
    showDetails: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    elementColor() {
      let color = 'secondary';
      if(this.element.type === 'belief') {
        color = 'teal lighten-2';
      }
      else if(this.element.type === 'hypothesis') {
        color = 'cyan lighten-1';
      }
      return color;
    }
  },
};
</script>
<style scoped>
.raison-element-chip {
  border-radius: 15px;
  background: #a6eeea;
  padding: 4px 24px 4px 24px;
  margin: 2px;
  text-overflow: ellipsis;
  overflow: hidden;
  text-justify: center;
  font-weight: bold;
  word-wrap: break-word;
  display: inline-block;
  font-size: 14px;
  color: #000;
}
.raison-element-chip:hover {
  cursor: pointer;
}
</style>
